import styled from 'styled-components';

export const IncidentCardsContainer = styled.div`
  .incident-card {
    transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
    border: 1px solid #e5e7eb;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }
    
    .incident-number {
      font-size: 0.9rem;
      font-weight: 600;
      color: #1a1a2e;
    }
    
    .incident-date {
      font-size: 0.75rem;
      color: #6b7280;
    }
    
    .incident-title {
      color: #374151;
      font-weight: 600;
      margin-bottom: 0.5rem;
    }
    
    .incident-description {
      color: #6b7280;
      line-height: 1.4;
    }
    
    .incident-details {
      margin-top: auto;
      
      small {
        display: block;
        margin-bottom: 0.25rem;
      }
    }
    
    .severity-badge {
      font-size: 0.7rem;
      font-weight: 600;
      text-transform: uppercase;
    }
    
    .status-badge {
      font-size: 0.7rem;
      font-weight: 600;
      text-transform: uppercase;
    }
  }
`;

export const IncidentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 1.5rem;
  padding: 1rem;
  background: #f9fafb;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
  }
`;

export const SearchSection = styled.div`
  flex: 1;
  max-width: 400px;
  
  .form-control {
    border-radius: 8px;
    border: 1px solid #d1d5db;
    
    &:focus {
      border-color: #1a1a2e;
      box-shadow: 0 0 0 0.2rem rgba(26, 26, 46, 0.25);
    }
  }
  
  .input-group-text {
    background: #f9fafb;
    border: 1px solid #d1d5db;
    border-right: none;
    color: #6b7280;
  }
`;

export const FilterButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border: 1px solid #d1d5db;
  background: white;
  border-radius: 8px;
  color: #6b7280;
  font-size: 0.875rem;
  transition: all 0.2s ease-in-out;
  
  &:hover {
    background: #f9fafb;
    border-color: #9ca3af;
    color: #374151;
  }
  
  &:focus {
    outline: none;
    box-shadow: 0 0 0 0.2rem rgba(26, 26, 46, 0.25);
  }
`;

export const StatsContainer = styled.div`
  .stats-card {
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }
    
    .stats-number {
      font-size: 2.5rem;
      font-weight: 700;
      margin-bottom: 0.5rem;
    }
    
    .stats-label {
      font-size: 0.875rem;
      font-weight: 500;
      color: #6b7280;
      text-transform: uppercase;
      letter-spacing: 0.05em;
    }
  }
`;

export const IncidentFiltersContainer = styled.div`
  .card {
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    
    .card-header {
      background: #f9fafb;
      border-bottom: 1px solid #e5e7eb;
      border-radius: 12px 12px 0 0;
      
      strong {
        color: #374151;
        font-weight: 600;
      }
    }
    
    .form-label {
      font-weight: 500;
      color: #374151;
      margin-bottom: 0.5rem;
    }
    
    .form-select,
    .form-control {
      border: 1px solid #d1d5db;
      border-radius: 8px;
      
      &:focus {
        border-color: #1a1a2e;
        box-shadow: 0 0 0 0.2rem rgba(26, 26, 46, 0.25);
      }
    }
  }
`;

export const IncidentActions = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  
  .btn-group {
    .btn {
      border-radius: 6px;
      padding: 0.375rem 0.75rem;
      
      &:hover {
        transform: translateY(-1px);
      }
    }
  }
  
  .btn-outline-primary:hover {
    background-color: #1a1a2e;
    border-color: #1a1a2e;
  }
  
  .btn-outline-secondary {
    color: #6b7280 !important;
    border-color: #6b7280 !important;
    background-color: transparent !important;
  }
  
  .btn-outline-secondary:hover {
    background-color: #6b7280 !important;
    border-color: #6b7280 !important;
    color: white !important;
  }
  
  .btn-outline-danger:hover {
    background-color: #dc2626;
    border-color: #dc2626;
  }
  
  .btn-outline-info:hover {
    background-color: #0891b2;
    border-color: #0891b2;
  }
`;

export const IncidentTimeline = styled.div`
  position: relative;
  padding-left: 24px;

  .timeline-item {
    position: relative;
    margin-bottom: 16px;
    padding-left: 12px;
  }

  /* Linha vertical */
  &::before {
    content: '';
    position: absolute;
    left: 8px;
    top: 8px;
    bottom: 8px;
    width: 2px;
    background: #e5e7eb;
  }

  /* Ponto do evento */
  .timeline-dot {
    position: absolute;
    left: 2px;
    top: 10px;
    width: 12px;
    height: 12px;
    background: #1a1a2e;
    border-radius: 50%;
    z-index: 2;
  }

  .timeline-content {
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 12px;
  }

  .timeline-title {
    font-weight: 600;
    color: #111827;
    margin: 0 0 4px 0;
  }

  .timeline-description {
    color: #4b5563;
    font-size: 0.9rem;
    margin: 0 0 8px 0;
  }

  .timeline-meta {
    display: flex;
    gap: 12px;
    color: #6b7280;
    font-size: 12px;
  }

  .timeline-badge {
    font-size: 11px;
    font-weight: 600;
    padding: 2px 8px;
    border-radius: 999px;
    background: #eef2ff;
    color: #3730a3;
  }
`;

// Estilo idêntico ao utilizado em ModalTicketResponse.renderHistoryTab
export const SDTimelineItem = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 1rem;
  padding-left: 1rem;
  border-left: 2px solid #e9ecef;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    left: -6px;
    top: 0.5rem;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #0d6efd;
  }
  
  &.comment-item::before {
    background-color: #198754;
  }
  
  &.status-change::before {
    background-color: #ffc107;
  }
`;

export const SDTimelineContent = styled.div`
  flex: 1;
  margin-left: 1rem;
`;

export const SDTimelineTitle = styled.div`
  font-weight: 600;
  color: #495057;
  margin-bottom: 0.25rem;
`;

export const SDTimelineDescription = styled.div`
  color: #6c757d;
  font-size: 0.9rem;
  margin-bottom: 0.25rem;
`;

export const SDTimelineTime = styled.div`
  color: #adb5bd;
  font-size: 0.8rem;
`;

export const IncidentForm = styled.div`
  .form-section {
    background: #f9fafb;
    padding: 1.5rem;
    border-radius: 12px;
    border: 1px solid #e5e7eb;
    margin-bottom: 1.5rem;
    
    .section-title {
      font-size: 1.125rem;
      font-weight: 600;
      color: #374151;
      margin-bottom: 1rem;
      padding-bottom: 0.5rem;
      border-bottom: 2px solid #1a1a2e;
    }
  }
`;

export const FormSection = styled.div`
  background: #f9fafb;
  padding: 1.5rem;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  margin-bottom: 1.5rem;
  
  .section-title {
    font-size: 1.125rem;
    font-weight: 600;
    color: #374151;
    margin-bottom: 1rem;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid #1a1a2e;
  }
  
  .form-label {
    font-weight: 500;
    color: #374151;
    margin-bottom: 0.5rem;
  }
  
  .form-control,
  .form-select {
    border: 1px solid #d1d5db;
    border-radius: 8px;
    
    &:focus {
      border-color: #1a1a2e;
      box-shadow: 0 0 0 0.2rem rgba(26, 26, 46, 0.25);
    }
  }
  
  .form-text {
    color: #6b7280;
    font-size: 0.875rem;
  }
  
  .required-field {
    color: #dc2626;
  }
`;

export const IncidentReport = styled.div`
  .report-header {
    text-align: center;
    margin-bottom: 2rem;
    padding: 2rem;
    background: #f9fafb;
    border-radius: 12px;
    border: 1px solid #e5e7eb;
    
    .org-logo {
      max-width: 200px;
      height: auto;
      margin-bottom: 1rem;
    }
    
    .org-name {
      font-size: 1.5rem;
      font-weight: 700;
      color: #1a1a2e;
      margin-bottom: 0.5rem;
    }
    
    .org-address {
      color: #6b7280;
      font-size: 0.875rem;
    }
  }
  
  .report-section {
    margin-bottom: 2rem;
    
    .section-title {
      font-size: 1.25rem;
      font-weight: 600;
      color: #1a1a2e;
      margin-bottom: 1rem;
      padding-bottom: 0.5rem;
      border-bottom: 2px solid #e5e7eb;
    }
    
    .info-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
      gap: 1rem;
      margin-bottom: 1rem;
    }
    
    .info-item {
      .info-label {
        font-weight: 600;
        color: #374151;
        margin-bottom: 0.25rem;
      }
      
      .info-value {
        color: #6b7280;
        padding: 0.5rem;
        background: #f9fafb;
        border-radius: 6px;
        border-left: 3px solid #1a1a2e;
      }
    }
  }
`;

// Botões de ação para a lista (mesma aparência dos cards)
export const ListActionButton = styled.button`
  background: rgba(26, 26, 46, 0.1);
  border: 1px solid rgba(26, 26, 46, 0.2);
  color: #1a1a2e;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  text-decoration: none;
  margin-left: 8px;

  &:hover {
    background: #1a1a2e;
    color: #ffffff;
    transform: translateY(-1px);
  }

  &.primary:hover { background: #1a1a2e; }
  &.secondary:hover { background: #6b7280; }
  &.danger:hover { background: #dc2626; }
  &.info:hover { background: #0891b2; }
`;

// Estilos de badges para a visualização em lista, iguais aos do card
export const ListBadgesStyles = styled.div`
  .badge {
    font-size: 10px;
    font-weight: 600;
    padding: 4px 8px;
    border-radius: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .badge-severity {
    &.BAIXA { background: #d1fae5; color: #065f46; }
    &.MEDIA { background: #fef3c7; color: #92400e; }
    &.ALTA { background: #fee2e2; color: #991b1b; }
    &.CRITICA { background: #f3f4f6; color: #374151; }
  }

  .badge-status {
    &.ABERTO { background: #fee2e2; color: #991b1b; }
    &.EM_ANALISE { background: #fef3c7; color: #92400e; }
    &.CONCLUIDO { background: #d1fae5; color: #065f46; }
    &.ARQUIVADO { background: #6b7280; color: #ffffff; }
  }
`;

// Estilos para filtros seguindo o padrão do Service Desk
export const IncidentFilterHeader = styled.div`
  background: linear-gradient(135deg, rgba(26, 26, 46, 0.02) 0%, rgba(244, 241, 222, 0.05) 100%);
  border-radius: 12px;
  padding: 20px;
  margin: 0;
  border: 1px solid rgba(26, 26, 46, 0.1);
`;

export const FilterSection = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
  min-width: 300px;
`;

export const FilterContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  width: 100%;
`;

export const FilterInputContainer = styled.div`
  flex: 1.2;
`;

export const FilterSelectContainer = styled.div`
  flex: 1;
`;

export const FilterDateContainer = styled.div`
  flex: 0.8;
`;

export const CustomInputGroup = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
`;

export const SearchIconBox = styled.div`
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 5;
  color: #a7a7a7;
  font-size: 20px;
`;

export const CustomFormControl = styled.input`
  padding-left: 32px;
  border-radius: 50px !important;
  border: 1px solid #ced4da;
  padding: 8px 12px 8px 32px;
  background: #ffffff;
  color: #495057;
  transition: all 0.2s ease;
  font-size: 14px;
  width: 100%;
  cursor: text !important;
  caret-color: #0d6efd !important;

  &:focus {
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    outline: none;
    cursor: text !important;
    caret-color: #0d6efd !important;
  }

  &::placeholder {
    color: #a7a7a7;
    font-style: italic;
  }
`;

export const CustomSelect = styled.select`
  padding-left: 15px;
  border-radius: 50px !important;
  color: #a7a7a7;
  font-style: italic;
  border: 1px solid #ced4da;
  padding: 8px 12px 8px 15px;
  background: #ffffff;
  transition: all 0.2s ease;
  font-size: 14px;
  width: 100%;
  cursor: pointer !important;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23666' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 16px;

  &:focus {
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    outline: none;
    cursor: pointer !important;
  }
`;

export const CustomDateInput = styled.input`
  border-radius: 50px !important;
  border: 1px solid #ced4da;
  padding: 8px 12px;
  background: #ffffff;
  color: #495057;
  transition: all 0.2s ease;
  font-size: 14px;
  width: 100%;
  cursor: text !important;
  caret-color: #0d6efd !important;

  &:focus {
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    outline: none;
    cursor: text !important;
    caret-color: #0d6efd !important;
  }

  &::placeholder {
    color: #a7a7a7;
    font-style: italic;
  }
`;

export const CustomButton = styled.button`
  border: 1px solid #6c757d;
  color: #6c757d;
  background: #ffffff;
  font-weight: 500;
  border-radius: 6px;
  padding: 8px 12px;
  transition: all 0.2s ease;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 14px;

  &:hover {
    background: #6c757d;
    color: #ffffff;
    border-color: #6c757d;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.25);
  }
`;

// Estilos customizados para badges na tela de detalhes do incidente
export const CustomBadgeStyles = styled.div`
  .badge {
    &.bg-secondary {
      &.status-ARQUIVADO {
        background-color: #6b7280 !important;
        color: #ffffff !important;
      }
    }
    
    // Estilo para badges de sistemas afetados
    &.systems-affected {
      background-color: #6b7280 !important;
      color: #ffffff !important;
    }
  }
`;

// Botões de ação para a tela de detalhes do incidente
export const DetailActionButton = styled.button`
  background: rgba(26, 26, 46, 0.1);
  border: 1px solid rgba(26, 26, 46, 0.2);
  color: #1a1a2e;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  text-decoration: none;
  margin-right: 8px;

  &:hover {
    background: #1a1a2e;
    color: #ffffff;
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }

  &.primary:hover { background: #1a1a2e; }
  &.secondary:hover { background: #6b7280; }
  &.danger:hover { background: #dc2626; }
  &.info:hover { background: #0891b2; }
`;
